import {
  FlagType,
  getAllCountries,
  isCountryCode,
  type Country,
  type CountryCode,
} from 'react-native-country-picker-modal';

export function normalizeCurrencyCode(
  value: unknown,
  fallback: string = 'KES',
): string {
  if (typeof value !== 'string') return String(fallback || 'KES');
  const normalized = value.trim().toUpperCase();
  if (!normalized) return String(fallback || 'KES');
  // ISO 4217 is typically 3 letters; we keep it permissive but stable.
  return normalized;
}

export function extractCountryCurrency(country: unknown): string | null {
  const raw = (country as any)?.currency;
  if (Array.isArray(raw)) {
    const first = raw[0];
    return typeof first === 'string' ? first : null;
  }
  if (typeof raw === 'string') return raw;
  return null;
}

const currencyCache = new Map<string, string>();

export async function currencyForCountryCode(
  countryCode: string,
  fallback: string = 'KES',
): Promise<string> {
  const code = String(countryCode || '').toUpperCase();
  const fb = normalizeCurrencyCode(fallback, 'KES');

  if (!code) return fb;
  if (currencyCache.has(code)) return currencyCache.get(code)!;

  if (!isCountryCode(code)) return fb;

  try {
    // Narrow to the requested countryCode to avoid extra work.
    const countries = (await getAllCountries(
      FlagType.EMOJI,
      'common',
      undefined,
      undefined,
      [code as CountryCode],
    )) as Country[];
    const picked = countries?.[0];
    const extracted = normalizeCurrencyCode(extractCountryCurrency(picked), fb);
    currencyCache.set(code, extracted);
    return extracted;
  } catch {
    return fb;
  }
}
